import {Injectable} from '@angular/core';
import {AttachmentDTO} from "../../api/api";
import {AttachmentPreviewComponent} from "../../../pages/datasets/attachment-explorer/attachment-preview/attachment-preview.component";
import {AttachmentLinkComponent} from "../../../pages/datasets/attachment-explorer/attachment-link/attachment-link.component";
import {ModalService} from "./modal.service";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class OpenModalService {

  constructor(private modal: ModalService, private translate: TranslateService) {
  }

  /* -------------------------------------------------------------
                           Attachment Modal
   ---------------------------------------------------------------*/
  public attachmentLinkAttachmentToEntries(attachment: AttachmentDTO) {
    this.modal.showNavigationModal({
      entryComponent: {value: AttachmentLinkComponent, data: attachment},
      title: this.translate.instant('lang.globals.linkAttachment'),
      icon: 'attachmentLink',
      modalOptions: {windowClass: 'bigXL'}
    }).then(() => {
    }).catch(() => {

    });
  }

  public attachmentShowPreview(attachment: AttachmentDTO) {
    this.modal.showNavigationModal({
      entryComponent: {value: AttachmentPreviewComponent, data: attachment},
      title: 'Preview',
      icon: 'preview',
      modalOptions: {size: 'xl'}
    }).then(() => {

    }).catch(() => {

    });
  }
}
